import React, { useReducer, useEffect } from "react";
import PropTypes from "prop-types";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import Box from "@mui/material/Box";

// Define the Tour component
const Tour = (props) => {
  // Set up the reducer function
  const initialState = props.initialState;
  const visited = localStorage.getItem("toursVisited");
  if (
    (!visited || visited.indexOf("ProjectTitleBar") == -1) &&
    props.id != "DashboardAllProjects" &&
    initialState.steps[0].target != ".tour-stop-ptb1"
  ) {
    initialState.steps.unshift(
      {
        target: ".tour-stop-ptb1",
        content: (
          <Box>
            <p>
              The current Client and Project will show here throughout the tool.
            </p>
          </Box>
        ),
        disableBeacon: true,
      },
      {
        target: ".tour-stop-ptb2",
        content: (
          <Box>
            <p>
              Click here to activate the Collab Center&apos;s AI query window
            </p>
          </Box>
        ),
      },
      {
        target: ".tour-stop-ptb3",
        content: (
          <Box>
            <p>
              Click here to activate &quot;Help Mode&quot;. This icon will
              change color, indicating the Help Mode is enabled. Until it is
              deactivated (by clicking on it again), elements on this page will
              show their respective help text when clicked.
            </p>
          </Box>
        ),
      },
      {
        target: ".tour-stop-ptb4",
        content: (
          <Box>
            <p>
              Click here to open a new browser tab with the relevant
              documentation for this module.
            </p>
          </Box>
        ),
      },
    );

    localStorage.setItem(
      "toursVisited",
      visited ? visited + "|ProjectTitleBar" : "ProjctTitleBar",
    );
  }

  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case "START":
        return { ...state, run: true };
      case "RESET":
        return { ...state, stepIndex: 0 };
      case "STOP":
        return { ...state, run: false };
      case "NEXT_OR_PREV":
        return { ...state, ...action.payload };
      case "RESTART":
        return {
          ...state,
          stepIndex: 0,
          run: true,
          loading: false,
          //key: new Date(),
        };
      default:
        return state;
    }
  };

  const [tourState, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (!visited || visited.indexOf(props.id) == -1) {
      dispatch({ type: "START" });
      localStorage.setItem(
        "toursVisited",
        visited ? visited + "|" + props.id : props.id,
      );
    }
  }, []);

  const callback = (data) => {
    const { action, index, type, status } = data;
    if (
      action === ACTIONS.CLOSE ||
      (status === STATUS.SKIPPED && tourState.run) ||
      status === STATUS.FINISHED
    ) {
      dispatch({ type: "STOP" });
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      dispatch({
        type: "NEXT_OR_PREV",
        payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
      });
    }
  };
  const startTour = () => {
    dispatch({ type: "RESTART" });
  };
  return (
    <>
      <JoyRide
        key={new Date()}
        {...tourState}
        continuous={true}
        showProgress={true}
        callback={callback}
        showSkipButton={true}
        styles={{
          options: {
            arrowColor: "#154360",
            backgroundColor: "#154360",
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "#643f69",
            textColor: "#ffffff",
            width: props.width || 300,
            zIndex: 1000,
          },
          tooltipContainer: {
            textAlign: "left",
          },
          tooltip: {
            borderRadius: 15,
          },
          buttonBack: {
            marginRight: 10,
            color: "#ffffff",
          },
        }}
        locale={{
          last: "End tour",
        }}
      />
    </>
  );
};
export default Tour;

Tour.propTypes = {
  initialState: PropTypes.object,
  width: PropTypes.number,
  id: PropTypes.string,
};

/*
      <button className="btn btn-primary" onClick={startTour}>
        Start Tour
      </button>
*/
